import { render, staticRenderFns } from "./IconCopyToClipBoard.vue?vue&type=template&id=796a4062"
import script from "./IconCopyToClipBoard.vue?vue&type=script&lang=js"
export * from "./IconCopyToClipBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports